import React, { useRef, useState } from 'react';

import { useMount } from 'react-use';

export const useImagesLoaded = (): {
  contentRef: React.MutableRefObject<HTMLDivElement | null>;
  imagesLoaded: boolean;
} => {
  const contentRef = useRef<HTMLDivElement | null>(null);
  const [imagesToLoad, setImagesToLoad] = useState(0);
  const [imagesLoaded, setImagesLoaded] = useState(0);

  const handleImageLoad = () => {
    setImagesLoaded(prevImagesLoaded => prevImagesLoaded + 1);
  };

  useMount(() => {
    let toLoad = 0;
    const images = contentRef?.current?.querySelectorAll('img');
    if (images) {
      images.forEach(image => {
        if (!image.complete) {
          image.addEventListener('load', handleImageLoad);
          toLoad += 1;
        }
      });
    }

    setImagesToLoad(toLoad);
  });

  return { contentRef, imagesLoaded: imagesLoaded === imagesToLoad };
};
